
import type { Athlete, UserProfile } from '../types';

export interface DraftingStats {
  athleteId: string;
  totalTimeDrafting: number; // in seconds
  totalEnergySavedKj: number;
  isEstimated?: boolean; // true if athlete had no power meter and stats are modeled
}

// NOTE: The implementation of calculateDraftingStats has been moved 
// to Firebase Cloud Functions to protect the proprietary algorithm.
// Please see cloudAnalysisService.ts
// The info contained in the drafting function is private and exclusive property of RaceLineIQ
// This is considered a trade secret and is not shared publicly

/**
 * Enriches athlete objects with physical demographics (height, weight, bike weight)
 * from the active user profile prior to sending telemetry to the Cloud Function.
 */
export const enrichAthletesWithUserProfile = (
  athletes: Athlete[],
  currentUserUid?: string,
  userProfile?: UserProfile | null
): Athlete[] => {
  if (!userProfile) return athletes;

  const heightCm = (userProfile.heightFeet || userProfile.heightInches)
    ? ((userProfile.heightFeet || 0) * 12 + (userProfile.heightInches || 0)) * 2.54
    : undefined;

  const bikeWeightKg = userProfile.bikeWeightLbs
    ? userProfile.bikeWeightLbs / 2.20462
    : undefined;

  const userWeightKg = userProfile.weightLbs
    ? userProfile.weightLbs / 2.20462
    : undefined;

  return athletes.map(athlete => {
    const isCurrentUser = Boolean(currentUserUid && (athlete.userId === currentUserUid || athlete.id === currentUserUid));
    if (!isCurrentUser) return athlete;

    return {
      ...athlete,
      weight: userWeightKg || athlete.weight,
      height: athlete.height || heightCm,
      bikeWeight: athlete.bikeWeight || bikeWeightKg
    };
  });
};